<template>
  <div>
    <ul class="fr operation_list">
      <li class="fl print_btn" @click="printTable">打印</li>
    </ul>
    <section ref="print">
    <div id="printTable">
      <!--id="printTable"  v-show="!loading"-->

      <table class="table table_content" v-show="!loading">
        <caption class="table_box" style="font-size:16px;margin-bottom: 20px;"> 浙江省机关事业养老保险待遇计发(预发)表</caption>
        <tr>
          <td>单位名称</td>
          <td colspan="5">{{tableInfo.company_name}}</td>
          <td>单位编号</td>
          <td >{{tableInfo.company_id}}</td>
        </tr>
        <tr>
          <td >姓名</td>
          <td>{{tableInfo.username}}</td>
          <td>性别</td>
          <td>{{tableInfo.sex}}</td>
          <td>民族</td>
          <td>{{tableInfo.nation}}</td>
          <td>社会保障号码</td>
          <td colspan="2">{{tableInfo.social_security_account}}</td>
        </tr>
        <tr>
          <td>出生日期</td>
          <td>{{tableInfo.birthday}}</td>
          <td colspan="3">参加工作日期</td>
          <td>{{tableInfo.work_time}}</td>
          <td>手机号</td>
          <td>{{tableInfo.mobile}}</td>
        </tr>
        <tr>
          <td>通讯地址</td>
          <td colspan="5">{{addressInfo}}</td>
          <td>邮政编码</td>
          <td>{{tableInfo.postal_code}}</td>
        </tr>
        <tr>
          <td>开户行名称</td>
          <td colspan="5">{{tableInfo.bank_name}}</td>
          <td>开户名</td>
          <td>{{tableInfo.bank_username}}</td>
        </tr>
        <tr>
          <td>银行账号</td>
          <td colspan="5">{{tableInfo.bank_account}}</td>
          <td>开户行行号</td>
          <td>{{tableInfo.bank_number}}</td>
        </tr>
        <tr>
          <td rowspan="9">待遇核定基础信息</td>
          <td colspan="2">退休类别</td>
          <td>{{tableInfo.retirement_type}}</td>
          <td>退休日期</td>
          <td>{{tableInfo.retirement_date}}</td>
          <td>上年度月社平工资</td>
          <td>{{tableInfo.average_salary_month}}</td>
        </tr>
        <tr>
          <td colspan="2">缴费（工作）年限</td>
          <td>{{tableInfo.accumulated_payment_date}}</td>
          <td>其中视同缴费年限</td>
          <td>{{tableInfo.payment_date}}</td>
          <td>其中实际缴费年限</td>
          <td>{{tableInfo.actual_payment_date}}</td>
        </tr>
        <tr>
          <td colspan="2">平均缴费指数</td>
          <td>{{tableInfo.average_payment_index}}</td>
          <td>视同缴费指数</td>
          <td>{{tableInfo.contribution_index}}</td>
          <td>实际缴费指数</td>
          <td>{{tableInfo.actual_average_payment_index}}</td>
        </tr>
        <tr>
          <td colspan="2">个人账户储存额</td>
          <td>{{tableInfo.personal_account_storage}}</td>
          <td>计发月数</td>
          <td>{{tableInfo.month_count}}</td>
          <td>过渡系数</td>
          <td>{{tableInfo.proportion}}</td>
        </tr>
        <tr>
          <td colspan="2">职业年金储存额</td>
          <td>{{tableInfo.profession_account_total}}</td>
          <td colspan="2">计发比例</td>
          <td colspan="2">{{tableInfo.account}}</td>
        </tr>
        <tr>
          <td colspan="2">转业时间</td>
          <td>{{tableInfo.military_revolution_time}}</td>
          <td colspan="2">转业时部队职务/技术等级</td>
          <td colspan="2">{{tableInfo.military_position}}{{tableInfo.military_rank }}</td>
        </tr>
        <!--<tr>-->
          <!--<td colspan="2">老办法计发比例</td>-->
          <!--<td colspan="5">{{tableInfo.account}}</td>-->
        <!--</tr>-->
        <tr>
          <td colspan="2">退休时人事信息</td>
          <td colspan="5">{{tableInfo.personnel_info_retirement}}</td>
        </tr>
        <tr>
          <td colspan="2">2014年9月人事信息</td>
          <td colspan="5">{{tableInfo.personnel_info_special_point}}</td>
        </tr>
        <tr>
          <td colspan="3">过渡期内最后一次职务升降信息</td>
          <td colspan="2">{{tableInfo.transition_period_last_position_info}}</td>
          <td>职务升降时间</td>
          <td>{{tableInfo.position_change_time}}</td>
        </tr>
        <tr>
          <td colspan="3">升降后职务对应的2014年9月基本工资标准</td>
          <td colspan="5">{{tableInfo.position_change_basic_wage}}</td>
        </tr>
        <tr>
          <td colspan="8">新老待遇计发办法对比</td>
        </tr>
        <tr>
          <td rowspan="12">老办法</td>
          <td rowspan="6">浙政发【2015】25号文件规定的老办法计发待遇标准Q</td>
          <td colspan="2">基本退休费A*M</td>
          <td>{{tableInfo.old_basic_retirement_fees_am}}</td>
          <td rowspan="12">新办法</td>
          <td rowspan="2">基础养老金</td>
          <td rowspan="2">{{tableInfo.new_basic_pension}}</td>
        </tr>
        <tr>
          <td colspan="2">退休补贴B</td>
          <td>{{tableInfo.old_retirement_allowance_b}}</td>
        </tr>
        <tr>
          <td colspan="2" rowspan="2">国办发【2015】3号增资C</td>
          <td rowspan="2">{{tableInfo.old_increase_c}}</td>
          <td rowspan="3">过渡性养老金</td>
          <td rowspan="3">{{tableInfo.new_transition_period_pension}}</td>
        </tr>
        <tr></tr>
        <tr>
          <td colspan="2">工资增长率∏</td>
          <td>{{tableInfo.old_wages_growth_rate}}</td>
        </tr>
        <tr>
          <td colspan="2">合计Q</td>
          <td>{{tableInfo.old_total_q}}</td>
          <td rowspan="3">个人账户养老金</td>
          <td rowspan="3">{{tableInfo.new_personal_account_pension}}</td>
        </tr>
        <tr>
          <td rowspan="5">职务升降前后累计待遇差H</td>
          <td colspan="2">A1*M1+B1+C1</td>
          <td>{{tableInfo.old_am_b1_c1}}</td>
        </tr>
        <tr>
          <td colspan="2">A*M+B+C</td>
          <td>{{tableInfo.old_am_b_c}}</td>
        </tr>
        <tr>
          <td colspan="2">两者差额</td>
          <td>{{tableInfo.old_diff}}</td>
          <td rowspan="2">职业年金</td>
          <td rowspan="2">{{tableInfo.profession_account_storage}}</td>
        </tr>
        <tr>
          <td colspan="2">工资增长率∏1</td>
          <td>{{tableInfo.old_wages_growth_rate_1}}</td>
        </tr>
        <tr>
          <td colspan="2">累计差额H</td>
          <td>{{tableInfo.old_cumulative_diff_h}}</td>
          <td rowspan="2">新办法待遇合计</td>
          <td rowspan="2">{{tableInfo.new_total}}</td>
        </tr>
        <tr>
          <td colspan="3">最终办法待遇标准Q+H</td>
          <td>{{tableInfo.old_q_h}}</td>
        </tr>
        <tr>
          <td >新办法高于老办法金额</td>
          <td colspan="3">{{tableInfo.new_above_old_money == 0? '': tableInfo.new_above_old_money}}</td>
          <td>新老过渡发放比例</td>
          <td colspan="3">{{tableInfo.enjoy_proportion == 0? '': tableInfo.enjoy_proportion}}</td>
        </tr>
        <!--<tr>-->
          <!--<td>新办法低于老办法发放金额</td>-->
          <!--<td colspan="3">{{tableInfo.new_below_old_payment}}</td>-->
          <!--<td>新办法高于老办法发放金额</td>-->
          <!--<td colspan="3">{{tableInfo.new_above_old_payment}}</td>-->
        <!--</tr>-->
        <tr>
          <td>应发月养老金合计</td>
          <td colspan="7">{{tableInfo.total_pension}}</td>
        </tr>
        <tr>
          <td>社保经办机构意见</td>
          <td colspan="7">
            <p style="text-align:left;">本计发(预发)表不包含历年养老金调整金额，从{{tableInfo.treatment_start_time}}起执行。</p>
            <p style="display:inline-block;width: 50%;text-align:left;float: left;">经办人:{{tableInfo.admin_name}}</p>
            <p style="display:inline-block;width: 50%;text-align:center;">经办机构盖章:{{currentTime}}</p>
          </td>
        </tr>
      </table>
      <loading v-show="loading"></loading>
    </div>
    </section>
  </div>
</template>
<script>
  import axios from 'axios'
  import loading from '../../libs/loading'
  import locations from '../../libs/location_libs'
  import moment from 'moment'

  export default {
    name:'table0',
    components:{
      loading
    },
    data () {
      return {
        id:this.$route.params.id,
        currentTime:'',
        params:{
          years:'0',
          mounths:'0'
        },
        tableInfo:{},
        loading:true,
        addressInfo:''
      }
    },
    mounted:function(){
      this.searchPension();
    },
    methods:{
      printTable:function(){
        // let bdhtml=window.document.body.innerHTML;
        // let prnhtml=document.getElementById('printTable').innerHTML;
        // let sprnstr="<!--startprint-->"; //开始打印标识字符串有17个字符
        // let eprnstr="<!--endprint-->"; //结束打印标识字符串
        // document.getElementById('app').innerHTML=prnhtml;
        // document.getElementById('app').children[0].className='table view_table';
        // window.print();
        // window.document.body.innerHTML=bdhtml;
        // document.location.reload();

        // prnhtml=bdhtml.substr(bdhtml.indexOf(sprnstr)+17); //从开始打印标识之后的内容
        // prnhtml=prnhtml.substring(0,prnhtml.indexOf(eprnstr)); //截取开始标识和结束标识之间的内容
        // window.document.body.innerHTML=prnhtml; //把需要打印的指定内容赋给body.innerHTML
        // window.print(); //调用浏览器的打印功能打印指定区域
        // window.document.body.innerHTML=bdhtml;//重新给页面内容赋值；
        // this.$print(this.$refs.print)


        let subOutputRankPrint = document.getElementById('printTable');
        let newContent = subOutputRankPrint.innerHTML;
        let oldContent = document.body.innerHTML;
        document.body.innerHTML = newContent;
        window.print();
        window.location.reload();
        document.body.innerHTML = oldContent;
        return false;
      },

      searchPension:function(){
          axios.get('/user/getAdvance',{
            params:{
              id:this.id
            }
          }).then((response)=>{
            if(response.data.code==22000){
              if(response.data.result.constructor!=Array){
                  this.tableInfo=response.data.result;
                  let province = response.data.result.address_province,
                      city = response.data.result.address_city,
                      district = response.data.result.address_district,
                      address_detail = response.data.result.address_detail;
                      this.addressInfo=locations.locations[province]['name']
                        +locations.locations[province]['sub'][city]['name']
                        +locations.locations[province]['sub'][city]['sub'][district]['name']
                        +address_detail
                }
                this.loading=false;

              this.currentTime  =moment().format("YYYY年MM月DD日")
              this.tableInfo.treatment_start_time =moment(this.tableInfo.treatment_start_time).format("YYYY年MM月DD日")
          }else if(response.data.code==50001){
            window.location.href='/#/login';
          }
        })
      }

    }
  }
</script>
<style lang="less" scoped>
  .view_table{
    width: 900px!important;
    margin:0 auto!important;
  }
  td{
    border-right:1px solid #e1e7f6;
    text-align: center;
    width:12.5%;
  }
  .table{
    border-right: none;

  }
  .operation_list{
  li{
    cursor: pointer;
    padding-left: 30px;
    margin-left: 22px;
  }
  }
  .print_btn{
    background: url("../../../static/images/print.png") 5px center no-repeat;
    background-size: 18px 18px;
  }
  .select_date{
    li{
      margin-right: 10px;
    }
    select{
      border:1px solid #e1e7f6;
      height:28px;
      background-color: #fff;

    }
  }
  .search_btn{
    padding:0 10px;
    background: #00a5fa;
    color: #fff;
    height: 28px!important;
    line-height: 28px!important;
    border-radius: 5px;
    margin-top: 10px;
  }
  /*@page {*/
    /*size: 210mm 290mm​;  !* auto is the initial value *!*/
    /*margin: 0mm auto; !* this affects the margin in the printer settings *!*/
  /*}*/
  .table_box{
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/pension/table0.vue